import React from 'react'
import styled from 'styled-components'
import { Info } from 'react-feather'
import { useIntl } from 'react-intl'
import { Card, CardBody } from 'reactstrap'

import { RowContainer } from '../styles'

import { queries } from '~/constants/mediaQuery'

export const LegacyInsightsCard = ({
  showOldReports,
  setShowOldReports,
  loading,
}) => {
  const intl = useIntl()

  return (
    <RowContainer>
      <Card
        className="w-100"
        style={{ padding: '0.5em 0', marginBottom: '1em' }}
      >
        <LegacyCardBody>
          <div>
            <Info size="25px" min="25px" color="#F56565" />
            <span>{intl.formatMessage({ id: 'insight-legacy-warning' })}</span>
          </div>
          <button
            disabled={loading}
            style={{
              backgroundColor: loading ? '#E2E8F0' : 'transparent',
              cursor: loading ? 'not-allowed' : 'pointer',
              color: '#2D3748',
              border: '1px solid #E2E8F0',
              padding: '0.7em 0.5em',
            }}
            onClick={() => setShowOldReports(prevState => !prevState)}
          >
            {showOldReports
              ? intl.formatMessage({ id: 'View new reports' })
              : intl.formatMessage({ id: 'View old reports' })}
          </button>
        </LegacyCardBody>
      </Card>
    </RowContainer>
  )
}

const LegacyCardBody = styled(CardBody)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1em;

    > span {
      text-align: center;
    }

    > svg {
      min-width: 25px;
    }
  }

  @media ${queries.less.mds} {
    flex-direction: column;

    > button {
      width: 100%;
    }
  }
`
